module.exports = __webpack_public_path__ + "img/country.6219c5c4.png";